import { render, staticRenderFns } from "./desuLimit.vue?vue&type=template&id=54a958b4&scoped=true"
import script from "./desuLimit.vue?vue&type=script&lang=js"
export * from "./desuLimit.vue?vue&type=script&lang=js"
import style0 from "./desuLimit.vue?vue&type=style&index=0&id=54a958b4&prod&scoped=true&lang=css"
import style1 from "./desuLimit.vue?vue&type=style&index=1&id=54a958b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a958b4",
  null
  
)

export default component.exports